// jQuery plugins used across pages.

jQuery.fn.preventDoubleSubmission = function() {
  $(this).on('submit',function(e){
    var $form = $(this);

    if ($form.data('submitted') === true) {
      // Previously submitted - don't submit again
      e.preventDefault();
    } else {
      // Mark it so that the next submit can be ignored
      $form.data('submitted', true);
      setTimeout(function() { $form.data('submitted', false) }, 10000);    //unlock it after 10s!
    }
  });

  // Keep chainability
  return this;
};
